import { TiptapReadOnlyContent } from "../../../component/tiptapEditor"
import QuestionArtifacts from "../../../component/questionArtifacts/QuestionArtifacts"
import {
  displayableArtifacts,
  type ArtifactLike,
} from "../../../utils/generatedArtifacts"

type QuestionDetailSectionProps = {
  title: string
  html?: string | null
  artifacts?: ArtifactLike[] | null
  nested?: boolean
}

const QuestionDetailSection = ({
  title,
  html,
  artifacts,
  nested = false,
}: QuestionDetailSectionProps) => {
  const hasHtml = Boolean(html?.trim())
  const hasArtifacts = displayableArtifacts(artifacts).length > 0

  return (
    <section
      className={`question-detail__section${nested ? " question-detail__section--nested" : ""}`}
    >
      <div className="question-detail__section-header">
        <span className="question-detail__section-label">{title}</span>
      </div>
      <div className="question-detail__section-body">
        {hasHtml || hasArtifacts ? (
          <>
            {hasHtml ? <TiptapReadOnlyContent html={html || ""} /> : null}
            <QuestionArtifacts artifacts={artifacts} />
          </>
        ) : (
          <p className="question-detail__empty">N/A</p>
        )}
      </div>
    </section>
  )
}

export default QuestionDetailSection
